// src/components/Footer.js
import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { azureColors } from '../theme';
import brandIcon from '../assets/profile.jpg';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        marginTop: 'auto',
        backgroundColor: azureColors.footer,
        color: '#FFFFFF',
        borderTop: `3px solid ${azureColors.primary}`,
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          py: 2.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component="img"
            src={brandIcon}
            alt="Mario Bozhinovski"
            sx={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.92)' }}>
            Mario Bozhinovski · Aldea Systems
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
          <Link component={RouterLink} to="/privacy" underline="hover" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem' }}>
            Privacy
          </Link>
          <Link component={RouterLink} to="/cookies" underline="hover" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem' }}>
            Cookies
          </Link>
          <Link component={RouterLink} to="/insights" underline="hover" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem' }}>
            Insights
          </Link>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            © {new Date().getFullYear()} All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
